import { defineQuery, useQuery } from '@pinia/colada';

import { DashboardAPI } from '@/apis';
import { CACHE_TIMES, QueryKeys } from '@/shared/queries';

/** Metric reference metadata. Rarely changes, so cached 8h. Non-legacy copy only. */
export const useMetricDetailsQuery = defineQuery(() =>
  useQuery({
    key: () => QueryKeys.dashboards.metricDetails(),
    query: ({ signal }) =>
      DashboardAPI.getMetricDetails({ legacyCopy: false }, { signal }).then((r) => r.data),
    staleTime: CACHE_TIMES.STATIC,
  }),
);
